(() => {
  const popupSelector = '[data-mbz-popup-shell]:not(.hide) [data-mbz-popup-root]';
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let popup = null;
  let previousFocus = null;
  let sizeChart = null;
  let sizeChartObserver = null;
  let mailbizWrapper = null;
  let mailbizObserver = null;
  let scheduled = false;

  const visible = (element) => element.isConnected && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';

  const labelPopup = (root) => {
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.tabIndex = -1;

    const heading = root.querySelector('.mbz-featured p');
    if (heading) {
      heading.id = heading.id || 'charry-mailbiz-offer-title';
      root.setAttribute('aria-labelledby', heading.id);
    }

    const close = root.querySelector('[data-mbz-popup-close-btn]');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', close.getAttribute('title') || close.textContent.trim());
    }

    root.querySelectorAll('input[data-mbz-input]').forEach((input) => {
      if (!input.getAttribute('aria-label') && !input.labels?.length && input.placeholder) {
        input.setAttribute('aria-label', input.placeholder);
      }
    });

    const consent = root.querySelector('[data-mbz-consent-term] input[type="checkbox"]');
    const consentText = root.querySelector('.mbz-consent-term-text');
    if (consent && consentText && !consent.labels?.length) {
      consentText.id = consentText.id || 'charry-mailbiz-consent-label';
      consent.setAttribute('aria-labelledby', consentText.id);
    }
  };

  const syncSizeChart = () => {
    const dialog = document.querySelector('dialog.pl-size-charts__modal');
    if (!dialog) return;

    if (dialog !== sizeChart) {
      sizeChartObserver?.disconnect();
      sizeChart = dialog;
      sizeChartObserver = new MutationObserver(syncSizeChart);
      sizeChartObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      dialog.querySelector('[autofocus]')?.removeAttribute('autofocus');

      const tableScroller = dialog.querySelector('.pl-size-charts__modal-body-table-wrapper');
      if (tableScroller) {
        tableScroller.tabIndex = 0;
        tableScroller.setAttribute('role', 'region');
        tableScroller.setAttribute('aria-label', 'Tabela de medidas. Use as setas para ver todas as colunas.');
      }
    }

    if (dialog.open) {
      dialog.removeAttribute('inert');
      if (!popup && !dialog.contains(document.activeElement)) {
        dialog.querySelector('.pl-size-charts__btn-close')?.focus({ preventScroll: true });
      }
    } else {
      dialog.setAttribute('inert', '');
      if (dialog.contains(document.activeElement)) {
        (popup || document.getElementById('MainContent'))?.focus({ preventScroll: true });
      }
    }
  };

  const syncPopup = () => {
    const next = document.querySelector(popupSelector);
    if (next) {
      labelPopup(next);
      if (next !== popup) {
        const active = document.activeElement;
        previousFocus = active instanceof HTMLElement && active !== document.body && visible(active) && !next.contains(active) ? active : null;
        popup = next;
        popup.focus({ preventScroll: true });
      }
    } else if (popup) {
      popup = null;
      const target = previousFocus?.isConnected && visible(previousFocus) ? previousFocus : document.getElementById('MainContent');
      previousFocus = null;
      target?.focus({ preventScroll: true });
    }
  };

  const syncMailbizObserver = () => {
    const wrapper = document.querySelector('[data-mbz-init-wrapper]');
    if (wrapper === mailbizWrapper) return;

    mailbizObserver?.disconnect();
    mailbizWrapper = wrapper;
    if (wrapper) {
      mailbizObserver = new MutationObserver(scheduleSync);
      mailbizObserver.observe(wrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  };

  const sync = () => {
    scheduled = false;
    syncSizeChart();
    syncMailbizObserver();
    syncPopup();
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };

  document.addEventListener('keydown', (event) => {
    if (!popup || !popup.isConnected) return;

    if (event.key === ' ' && document.activeElement?.matches('[data-mbz-popup-close-btn]')) {
      event.preventDefault();
      document.activeElement.click();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusables = [...popup.querySelectorAll(focusableSelector)].filter(visible);
    if (!focusables.length) {
      event.preventDefault();
      popup.focus({ preventScroll: true });
      return;
    }

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;
    if (!popup.contains(active)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && (active === first || active === popup)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  const help = document.querySelector('.help-customer');
  const helpButton = help?.querySelector('.help-button');
  const helpLinks = help?.querySelector('.list-options-help');
  if (help && helpButton && helpLinks) {
    const setHelpOpen = (open) => {
      helpButton.setAttribute('aria-expanded', String(open));
      helpButton.setAttribute('aria-label', open ? 'Fechar ajuda' : 'Abrir ajuda');
      helpLinks.hidden = !open;
      help.classList.toggle('showlist', open);
    };

    helpButton.addEventListener('click', () => {
      setHelpOpen(helpLinks.hidden);
    });

    help.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || helpLinks.hidden) return;
      event.preventDefault();
      event.stopPropagation();
      setHelpOpen(false);
      helpButton.focus();
    });

    help.addEventListener('focusout', (event) => {
      if (!help.contains(event.relatedTarget)) setHelpOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (!help.contains(event.target)) setHelpOpen(false);
    });
  }

  new MutationObserver(scheduleSync).observe(document.body, {
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });

  sync();
})();
